import React, { useState } from "react";
import TutorPaymentGreenDue from "./TutorPaymentGreenDue";
import TutorPaymentGreenOverDue from "./TutorPaymentGreenOverDue";
import TutorPaymentGreenPaid from "./TutorPaymentGreenPaid";

const TutorPaymentGreenAll = () => {
  const [activeTab, setActiveTab] = useState(0); // 0 is the index for the first tab

  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return <TutorPaymentGreenDue></TutorPaymentGreenDue>;
      case 1:
        return <TutorPaymentGreenOverDue></TutorPaymentGreenOverDue>;
      case 2:
        return <TutorPaymentGreenPaid></TutorPaymentGreenPaid>;
      default:
        return null;
    }
  };

  return (
    <div className="bg-green-100 h-screen">
      <div className="w-full h-20 flex justify-start pl-5 items-center bg-gree-100 shadow-md">
        <h2 className="text-xl text600 text-start text-green-900 font-montserrat">
          Payment
        </h2>
      </div>
      <div className="m-5 flex flex-row gap-5">
        <button
          onClick={() => setActiveTab(0)}
          className={activeTab === 0 ? "bg-green-900 shadow-xl rounded font-montserrat text-lg px-6 text-white py-2" : "bg-green-600 text-white rounded font-montserrat text-lg px-6 py-2"}
        >
          Payment Due
        </button>
        <button
          onClick={() => setActiveTab(1)}
          className={activeTab === 1 ? "bg-green-900 shadow-xl rounded font-montserrat text-lg px-6 text-white py-2" : "bg-green-600 text-white rounded font-montserrat text-lg px-6 py-2"}
        >
          Payment Over Due
        </button>
        <button
          onClick={() => setActiveTab(2)}
          className={activeTab === 2 ? "bg-green-900 shadow-xl rounded font-montserrat text-lg px-6 text-white py-2" : "bg-green-600 text-white rounded font-montserrat text-lg px-6 py-2"}
        >
          Payment Paid
        </button>
      </div>
      <div>{renderTabContent()}</div>
    </div>
  );
};

export default TutorPaymentGreenAll;
